import { render, staticRenderFns } from "./contentDetailCourse.vue?vue&type=template&id=706336d9&"
import script from "./contentDetailCourse.vue?vue&type=script&lang=js&"
export * from "./contentDetailCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports